<template>
  <div class="row">
    <div class="col-12">
      <app-positions-controller v-if="positions != undefined"
        :classifications="pageconfig.classifications"
        @command="executeCommand($event)"
        @change-classification="changeClassification($event)">
      </app-positions-controller>
      <component v-if="positions != undefined &&  positions[position] != undefined"
        :is = "view"
        :position="positions[position]"
        :positions = "positions"
        @position-selected = "selectPosition($event)">
      </component>
    </div>
  </div>
</template>

<script>
  import PositionsCard from './app-positions-card';
  import PositionsList from './app-positions-list';
  import PositionsThumbnail from './app-positions-thumbnail';
  import PositionsController from './app-positions-control';

  export default {
    name: "app-positions",
    components: {
      appPositionsCard: PositionsCard,
      appPositionsList: PositionsList,
      appPositionsThumbnail: PositionsThumbnail,
      appPositionsController: PositionsController
    },
    props: {
      pageconfig: { type: Object, requite: true }
    },
    data: function () {
      return {
        view: "",
        position: 0,
        classification: ""
      }
    },
    methods: {
      executeCommand: function (action) {
        switch (action) {
          case "previous":
            this.view = 'appPositionsCard';
            if (this.position >= 1) {
              this.position = this.position - 1;
            }
            break;
          case "random":
            this.view = 'appPositionsCard';
            this.position = Math.floor(Math.random() * (this.positions.length));
            break;
          case "list":
            this.view = 'appPositionsList';
            break;
          case "thumbnail":
            this.view = 'appPositionsThumbnail';
            break;
          case "next":
            this.view = 'appPositionsCard';
            if (this.position != (this.positions.length - 1)) {
              this.position = this.position + 1;
            }
            break;
        }
      },
      changeClassification: function (classification) {
        this.classification = classification;
        this.position = 0;
      },
      selectPosition: function (id) {
        this.view = 'appPositionsCard';
        this.position = id;
      }
    },
    computed: {
      positions: function () {
        if (this.classification != "" && this.classification != 'Todas') {
          let filtered = this.pageconfig.positions.filter(p => p.classification == this.classification);
          if (filtered.length == 0) {
            this.classification = 'Todas';
            return this.pageconfig.positions;
          }
          return filtered;
        }
        return this.pageconfig.positions;
      }
    },
    watch: {
      pageconfig: function() {
        this.position = 0;
        this.classification = 'Todas';
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/app-positions.vue